<h2>
  {{ data.titulo }}
</h2>

<p class="form-label title-blue-bimbo-cap mt-1 mb-1">*Añadir usuario:</p>
<div class="row d-flex justify-content-center mt-4">
  <div class="col">
    <div *ngIf="userList && !isLoading">
      <app-user-input-searcher
        keyForId="qrsharewith"
        [userList]="userList"
        label="Buscar usuario a compartir"
        [defaultValue]="currentUser"
        (selectedUserEmitter)="createShareQR($event)"></app-user-input-searcher>
    </div>
  </div>
  <div *ngIf="!userList || isLoading">
    <app-skeleton skeletonType="skeleton-input"></app-skeleton>
  </div>
</div>

<div class="mt-4">
  <div class="table-responsive">
    <table
      class="table t-elevated-shadow-cap"
      aria-describedby="partes por sesión">
      <thead>
        <tr>
          <th scope="col">Id localizador</th>
          <th scope="col">Compartido con</th>
          <th scope="col">Fecha</th>
          <th scope="col" class="text-center">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sharedQRListName">
          <td scope="row">{{ item.idLocalizador }}</td>
          <td scope="row">{{ item.usrDestino }}</td>
          <td scope="row">
            {{ item.fechaAlta | date: "dd-MMM-yyyy" : "" : "es-MX" }}
          </td>
          <td scope="row" class="text-center">
            <button
              type="button"
              mat-icon-button
              color="warn"
              ngbTooltip="Eliminar QR compartido"
              (click)="deleteQRCompartido(item)">
              <span>
                <mat-icon>delete</mat-icon>
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="d-flex justify-content-evenly align-content-center mb-2 mt-4">
  <div class="col-3 mx-1 p-1">
    <button
      type="button"
      id="close-qr-modal"
      (click)="closeModal()"
      class="btn btn-secondary-cap">
      <span> Cerrar </span>
    </button>
  </div>
</div>
